import React from 'react'
import { useInView, IntersectionOptions } from 'react-intersection-observer'
import Stack, { StackProps } from '@mui/material/Stack'

interface LoadMoreTriggerProps extends StackProps {
  fetchMoreHandler: () => void
  options?: IntersectionOptions
  LoaderContent?: () => React.ReactNode
}

export const LoadMoreTrigger = (props: LoadMoreTriggerProps) => {
  const { fetchMoreHandler, LoaderContent, children, options, ...stackProps } =
    props

  const { ref, inView } = useInView({
    threshold: 0,
    ...options,
  })

  React.useEffect(() => {
    if (inView) {
      fetchMoreHandler()
    }
  }, [inView, fetchMoreHandler])

  return (
    <Stack
      ref={ref}
      border="1px solid"
      borderColor="transparent"
      sx={{ width: '100%' }}
      {...stackProps}
      style={{ display: 'table-row' }}
    >
      {inView && (LoaderContent ? <LoaderContent /> : children)}
    </Stack>
  )
}

export default LoadMoreTrigger
